import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { GrowthBookService } from '../../../core/services/growthbook.service';
import { Apollo } from 'apollo-angular';
import { PageModel, SortModel } from 'src/app/rent-module/components/task-assignment-list-unassigned/abstract-task-assignment-list';
import { TasksService } from 'src/app/rent-module/shared/services/tasks/tasks.service';
import { LinkedTasksListViewDataSource } from './linked-tasks-list-view.data-source';

@Component({
  selector: 'app-linked-tasks-list-view',
  templateUrl: './linked-tasks-list-view.component.html',
  styleUrls: ['./linked-tasks-list-view.component.scss'],
})
export class LinkedTasksListViewComponent implements OnDestroy, OnChanges {

  @Input() orderId: string | undefined;
  @Input() linkedEntityId: string | undefined;

  defaultColumns = [
    'dueDateTimePeriod',
    'extendedState'
  ];

  // sorting
  public sortModel: SortModel;
  public sortOptions : SortModel[] = [
    { label: 'orderModule.linkedTasksListViewComponent.sortOptions.dueDateAsc', fieldName: 'dueDateTimePeriod', direction: "asc" }
  ];
  public defaultSortModel: SortModel = this.sortOptions[0];

  // states (not filterable at the moment)
  public states = ['NEW', 'ASSIGNED', 'UNASSIGNED', 'COMPLETED'];

  // pagination
  public pageModel: PageModel;
  public defaultPageModel: PageModel = { pageNumber: 0, pageSize : 5 };

  // indicates loading
  public loading = false;

  public dataSource: LinkedTasksListViewDataSource;

  constructor(
    private apollo: Apollo,
    public taskService: TasksService,
    private cdRef:ChangeDetectorRef,
    private growthBookService: GrowthBookService,
  ) { 
    this.pageModel = this.defaultPageModel;
    this.sortModel = this.defaultSortModel;
    this.dataSource = new LinkedTasksListViewDataSource(this.apollo);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.orderId && this.linkedEntityId) {
      this.loadTasks();
    }
  }

  loadTasks() {
    this.dataSource.loadTaskList({
      orderId: this.orderId,
      linkedEntityId: this.linkedEntityId,
      sortProperty: this.sortModel?.fieldName,
      sortDirection: this.sortModel?.direction,
      pageNumber: this.pageModel?.pageNumber,
      pageSize: this.pageModel?.pageSize,
    });
  }

  refetchTasks(force = false): void {
    this.dataSource.refetchQuery({
      orderId: this.orderId,
      linkedEntityId: this.linkedEntityId,
      sortProperty: this.sortModel?.fieldName,
      sortDirection: this.sortModel?.direction,
      pageNumber: this.pageModel?.pageNumber,
      pageSize: this.pageModel?.pageSize,
    }, force);
  }

  ngOnDestroy(): void {
    this.dataSource.disconnect();
  }

  onPageChange(event) {
    this.pageModel = { pageNumber: event.page, pageSize: event.rows };
    this.refetchTasks();
  }

}
